require('./brokerMiFID2UsPersonBlockingDisclaimer.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { FormattedText } = require('core/i18n').i18n;
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const { recordLinkV2 } = require('utilities/tagging');

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @constants
const { BROKER_PG_URL } = require('constants/index');

class BrokerMiFID2UsPersonBlockingDisclaimer extends React.Component {

    handleCTAClick() {
        const { history, immBrokerConvenienceMiFIDTest } = this.props;
        const continueUrl = immBrokerConvenienceMiFIDTest.get(
            "urlContinueOperation"
        )
            ? immBrokerConvenienceMiFIDTest.getIn(["urlContinueOperation", 0])
            : null;
        recordLinkV2({
            eventCategory: continueUrl,
            eventAction: 'lowerNavigation',
            eventLabel: 'navigationBackInvestmentButton',
        });
        history.push(BROKER_PG_URL)
    }

    render() {
        const {immBrokerConvenienceMiFIDTest} = this.props;
        const immUsPersonDisclaimer = immBrokerConvenienceMiFIDTest.getIn(['mifidv2','usPersonDisclaimers']);
        const disclaimers = immUsPersonDisclaimer.map((disclaimer) => (
            <div className="broker-mifid2-us-person-disclaimer__paragraph">
                <HTMLSafeInjector message={disclaimer.get("description")} />
            </div>
        ));

        return(
            <div className="broker-mifid2-us-person-disclaimer">
                <OKSectionBox className="broker-mifid2-us-person-disclaimer__box-container">
                    <div className="broker-mifid2-us-person-disclaimer__title-container">
                        <h2 className="broker-mifid2-us-person-disclaimer__title">
                            <FormattedText value="brokerMiFIDUSPersonDisclaimerView-title"/>
                        </h2>
                        <div className="broker-mifid2-us-person-disclaimer__content">
                            {disclaimers}
                        </div>
                        <div className="broker-mifid2-us-person-disclaimer__footer">
                            <OKButton onClick={() => this.handleCTAClick()}>
                                <FormattedText value="brokerMiFIDUSPersonDisclaimerView-ctaButton"/>
                            </OKButton>
                        </div>
                    </div>
                </OKSectionBox>
            </div>
        );
    }
}

BrokerMiFID2UsPersonBlockingDisclaimer.propTypes = {
    history: PropTypes.object.isRequired,
    immUsPersonDisclaimer: PropTypes.object.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
};

module.exports = withRouter(BrokerMiFID2UsPersonBlockingDisclaimer);
